import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography/Typography'
import QRCode from 'qrcode.react'
import {Loader} from 'components/Loader'
import TextInput from '@material-ui/core/TextField/TextField'
import StyleSheet from 'styles'
import Tooltip from '@material-ui/core/Tooltip'
import {SegmentedControl, Segment} from 'components'

const siteName = encodeURIComponent(process.env.REACT_APP_NAME)

const iOS = /^(iPhone|iPad|iPod)/.test(navigator.platform)

const apps = [
  {
    name: 'Authy 2-Factor Authentication',
    img: '/authenticators/authy.png',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.authy.authy',
    apple: 'https://itunes.apple.com/app/authy/id494168017'
  },
  {
    name: 'Google Authenticator',
    img: '/authenticators/google.png',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    apple: 'https://itunes.apple.com/app/google-authenticator/id388497605'
  },
  {
    name: 'LastPass Password Manager',
    img: '/authenticators/lastpass.png',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.lastpass.lpandroid',
    apple: 'https://itunes.apple.com/app/lastpass-password-manager/id324613447'
  },
  {
    name: 'Microsoft Authenticator',
    img: '/authenticators/microsoft.png',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.azure.authenticator',
    apple: 'https://itunes.apple.com/app/microsoft-authenticator/id983156458'
  }
]


export class Enable2faOtp extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    user: PropTypes.object,
    secret: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string
  }

  state = {store: iOS ? {value: 'apple', label: 'Apple App Store'} : {value: 'googlePlay', label: 'Google Play Store'}}

  get qrCode() {
    const {secret, user: {email}} = this.props
    return `otpauth://totp/${siteName}:${email}?secret=${secret}&issuer=${siteName}`
  }

  render = () =>
    <ol className={styles.steps}>
      <li>
        <Typography paragraph>Download an authenticator app.</Typography>
        <SegmentedControl active={this.state.store.label} onSelected={store => this.setState({store})}>
          <Segment dark label="Google Play Store" value="googlePlay"/>
          <Segment dark label="Apple App Store" value="apple"/>
        </SegmentedControl>
        <div className={styles.authenticators}>
          {apps.map(app =>
            <Tooltip title={app.name}>
              <a href={app[this.state.store.value]} target="_blank" rel='noopener noreferrer'>
                <img src={app.img} alt={app.name} className={styles[this.state.store.value]}/>
              </a>
            </Tooltip>
          )}
        </div>
        <Typography paragraph style={{fontSize: '0.9em', textAlign: 'center'}}>
          You can use any app that supports TOTP.
        </Typography>
      </li>
      <li>
        <Typography>Scan this QR code with your authenticator app.</Typography>
        {this.props.secret ?
          <Fragment>
            <div style={{alignSelf: 'center', padding: 20, background: '#FFF'}}>
              <QRCode className="test" value={this.qrCode}/>
            </div>
            <Typography style={{alignSelf: 'center', marginTop: 5}}>{this.props.secret}</Typography>
          </Fragment>
          :
          <Loader size={140}/>
        }
      </li>
      <li>
        <Typography>Enter your 2FA code to confirm setup is complete.</Typography>
        <TextInput label="2FA code" onChange={this.props.onChange} value={this.props.value} error={this.props.error}
                   helperText={this.props.helperText} />
      </li>
    </ol>
}

const styles = StyleSheet({
  authenticators: {
    alignSelf: 'center',
    padding: [14, 0, 4],
    margin: [0, -6],
    '& img': {
      width: 60,
      height: 60,
      margin: 6,
      transition: 'border-radius 500ms',
    }
  },
  googlePlay: {
    borderRadius: 30
  },
  apple: {
    borderRadius: 15
  },
  steps: {
    listStyle: 'none',
    counterReset: 'mfa-steps',
    position: 'relative',
    paddingLeft: 70,
    '& li': {
      counterIncrement: 'mfa-steps',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 10,
      '& p': {
        marginTop: 5,
      }
    },
    '& li:before': {
      content: 'counter(mfa-steps)',
      border: '2px solid #FFF',
      borderRadius: '50%',
      width: 50,
      height: 50,
      lineHeight: '50px',
      display: 'inline-block',
      textAlign: 'center',
      boxSizing: 'border-box',
      fontSize: '1.2em',
      fontWeight: 'bold',
      color: '#FFF',
      position: 'absolute',
      left: 0,
    }
  }
})